module.exports = __webpack_public_path__ + "5cd0f855a69cfdda3b937c5780491987.jpg";